import useSWR, { Fetcher, mutate } from "swr";
import useSWRImmutable from "swr/immutable";
import authAxios from "../../helpers/authAxios";
import { TaskType } from "../../components/TaskList";
import { Assignee, AssigneeType, remoteProjectAssignee } from "../Task/api";
import { useMemo } from "react";

export type TaskTotalType = {
  totalProjects: number;
  totalSubTasks: number;
  totalTasks: number;
  result: string[];
};

export type TaskOrderTotalType = {
  _id: string;
  totalProjects: number;
  totalSubTasks: number;
  totalTasks: number;
  updatedBy: { _id: string; name: string; profilepic: string };
  updatedOn: string;
};

export type ProjectsType = {
  _id: string;
  project_name: string;
};

export const getPriorityList = (url: string): Promise<TaskType[]> =>
  authAxios.get(url).then((resp) => resp?.data?.data);

export const getMyPriorityList = (url: string): Promise<TaskType[]> =>
  authAxios.get(url).then((resp) => resp.data.data);

export const getPriorityOrderList = (url: string): Promise<TaskType[]> =>
  authAxios.get(url).then((resp) => resp.data.data);

export const getMyPriorityListTotal = (url: string): Promise<TaskTotalType> =>
  authAxios.get(url).then((resp) => resp.data.data);

export const updatePriorityOrderList = (
  employeeId: string,
  taskPriorityId: string,
  formData: any
) =>
  authAxios.put(
    `/taskpriority/projects/${taskPriorityId}/${employeeId}`,
    formData
  );

export const getPriorityTotal = (url: string): Promise<TaskOrderTotalType> =>
  authAxios.get(url).then((resp) => {
    let result = resp.data.data;
    return result;
  });

const getAssignees = (url: string): Promise<AssigneeType[]> =>
  authAxios.get(url).then((resp) => {
    const assignees = resp.data?.data;
    return assignees;
  });

const getProjects = (url: string): Promise<ProjectsType[]> =>
  authAxios.get(url).then((resp) => {
    const userProjects = resp.data?.data;
    return userProjects;
  });

export const usePriorityList = (
  employeeId: string | undefined,
  projectId: string,
  status: string
) => {
  const { data, error, mutate } = useSWRImmutable(
    employeeId
      ? `/taskpriority/employees/list/${employeeId}/${projectId}/${status}`
      : null,
    getPriorityList
  );

  
  return {
    priorityList: data || [],
    isPriorityLoading: !error && !data,
    isPriorityError: error,
    priorityListMutate: mutate,
  };
};




export const useMyPriorityList = (projectId: string, status: string) => {
  const { data, error, mutate } = useSWRImmutable(
    `/taskpriority/mypriority/${projectId}/${status}`,
    getMyPriorityList
  );
  return {
    priorityList: data || [],
    isPriorityLoading: !error && !data,
    isPriorityError: error,
    priorityListMutate: mutate,
  };
};

export const usePriorityOrderList = (employeeId: string | undefined) => {
  const { data, error, mutate } = useSWRImmutable(
    employeeId ? `/taskpriority/employees/list/${employeeId}` : null,
    getPriorityOrderList
  );
  return {
    taskOrderList: data || [],
    isTasksListLoading: !error && !data,
    isError: error,
    mutate: mutate,
  };
};

export const useMyPriorityTotal = () => {
  const { data, error } = useSWRImmutable(
    `/taskpriority/mypriority/total`,
    getMyPriorityListTotal
  );
  return {
    myPriorityTotal: data,
    isLoading: !error && !data,
    isError: error,
  };
};

export const usePriorityTotal = (employeeId: string | undefined,filteredStatusId?: string) => {
  const { data, error ,mutate} = useSWRImmutable(
    
    employeeId ? `/taskpriority/employees/total/${employeeId}${
      filteredStatusId && filteredStatusId !== "All"
        ? `?filteredStatusId=${filteredStatusId}`
        : ""
    }` : null,
    getPriorityTotal
  );
  
  return {
    priorityTotal: data,
    isLoading: !error && !data,
    isError: error,
    refetch:mutate
  };
};

export const useEmployeeList = () => {
  const { data, error } = useSWRImmutable(
    `/taskpriority/employees/list`,
    getAssignees
  );
  return {
    assignees: data || [],
    isLoading: !error && !data,
    isError: error,
  };
};

export const useProjectsList = (employeeId: string | undefined) => {
  const { data, error } = useSWRImmutable(
    employeeId ? `/taskpriority/projects/list/${employeeId}` : null,
    getProjects
  );
  return {
    userProjects: data || [],
    isLoading: !error && !data,
    isError: error,
  };
};
